import { render, staticRenderFns } from "./uploadSetting.vue?vue&type=template&id=1d4282bd&scoped=true"
import script from "./uploadSetting.vue?vue&type=script&lang=js"
export * from "./uploadSetting.vue?vue&type=script&lang=js"
import style0 from "./uploadSetting.vue?vue&type=style&index=0&id=1d4282bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4282bd",
  null
  
)

export default component.exports